import { BulkOrganisationScreen } from "@/features/patients/features/overview/table/bulk/BulkOrganisationScreen";
import { patientsBulkActionBreadcrumbs } from "@/features/patients/features/overview/table/bulk/bulkNav";
import { parseBulkDiaryIdsSearch } from "@/features/patients/features/overview/table/bulk/bulkSearch";
import { useBulkDiaryIds } from "@/features/patients/features/overview/table/bulk/useBulkDiaryIds";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";

function BulkOrganisationRoute() {
    const search = Route.useSearch();
    const diaryIds = useBulkDiaryIds(search.diaryIds ?? []);

    h.useNav(
        diaryIds.length > 0
            ? patientsBulkActionBreadcrumbs({
                  action: "organisation",
                  diaryIds,
                  search: search as Record<string, unknown>,
              })
            : undefined
    );

    if (diaryIds.length === 0) return null;
    return <BulkOrganisationScreen diaryIds={diaryIds} />;
}

export const Route = createFileRoute("/_app/patients/bulk/organisation")({
    validateSearch: (search: Record<string, unknown>) => parseBulkDiaryIdsSearch(search),
    component: BulkOrganisationRoute,
});
